import React from 'react';

import Context     from '../../../../context';
import validations from '../../../../validations';

import { useFormik }      from 'formik';
import { useTranslation } from 'react-i18next';
import { IAcademicYearForm } from '../../../../types/academicYear.interface';

import {
  CustomInput,
  CustomModal,
  CustomButton2,
  CustomCheckBox,
  ResponsiveView,
} from '../../../../components';

// ? Dates come back from the API as full ISO strings; the inputs edit them as plain YYYY-MM-DD.
function toDateInput(value?: string): string {
  if (!value) return '';
  return new Date(value).toISOString().slice(0, 10);
}

const Update: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, updateFunction, isLoading, selectedYear } =
    React.useContext(Context.AcademicYearScreen);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<IAcademicYearForm>({
    enableReinitialize: true,
    initialValues: {
      key      : selectedYear?.key       ?? '',
      name     : selectedYear?.name      ?? '',
      startAt  : toDateInput(selectedYear?.startAt),
      endAt    : toDateInput(selectedYear?.endAt  ),
      isCurrent: selectedYear?.isCurrent ?? false,
    },
    validationSchema: validations.academicYear.academicYear.create,
    onSubmit: (values: IAcademicYearForm, { setSubmitting }) => {
      Promise.resolve(updateFunction!(values)).catch(() => setSubmitting(false));
    },
  });

  function submitHandler(): void {
    formik.submitForm();
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  return (
    <section id="academic-year-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal label="ویرایش سال تحصیلی" open={showModal === 'UPDATE'} onClose={() => setShowModal!('NONE')}>
          <ResponsiveView.Container className="create-form-content">
            <br />
            <hr />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="name"
                  name="name"
                  label={'نام سال تحصیلی'}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="key"
                  name="key"
                  label={'شناسه سال'}
                  value={formik.values.key}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.key && formik.touched.key}
                  errorText={formik.errors.key}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="startAt"
                  name="startAt"
                  label={'تاریخ شروع (میلادی)'}
                  value={formik.values.startAt}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.startAt && formik.touched.startAt}
                  errorText={formik.errors.startAt}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="endAt"
                  name="endAt"
                  label={'تاریخ پایان (میلادی)'}
                  value={formik.values.endAt}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.endAt && formik.touched.endAt}
                  errorText={formik.errors.endAt}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={12}>
                <CustomCheckBox
                  label={'سال جاری باشد'}
                  isChecked={formik.values.isCurrent}
                  onChecked={() => formik.setFieldValue('isCurrent', !formik.values.isCurrent)}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={() => setShowModal!('NONE')} title={t('cancel')} type="danger" />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t('submit')} />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Update;
